import {Link} from 'gatsby';
import React from 'react';

import {createLangShortcut} from '../../../utils/createLangShortcut';
import {getSectionHeaderBackgroundStyle, hasCollectionBackground} from '../../../utils/getCollectionBackground';
import {getCollectionMainTitleStyle} from '../../../utils/getH1Color';
import {getHeroCtaStyle} from '../../../utils/getHeroCtaStyle';
import './sectionHeader.css';

export default function SectionHeaderCentered(slice) {
  const text = slice.primary.section_header_body[0]?.text || slice.primary.section_header_body.text;
  const title = slice.primary.section_header_title[0]?.text || slice.primary.section_header_title.text;
  const titleStyle = getCollectionMainTitleStyle(slice.primary?.section_header_title_color);
  const bgStyle = getSectionHeaderBackgroundStyle(slice.primary.background_color);
  const hasBg = hasCollectionBackground(slice.primary.background_color);
  const localLink = slice.primary?.lank?.uid;
  const externalLink = slice.primary?.lank?.raw?.url;
  const linkLang = slice.primary?.lank?.lang;
  const action = slice?.primary?.action?.text;
  const ctaStyle = getHeroCtaStyle(slice.primary?.cta_background_color);
  const line = slice.primary?.line;

  return (
    <section
      className={
        slice?.source ?
          hasBg ?
            'bg-section tema' :
            'tema ' :
          hasBg ?
          'bg-section content' :
          'content'
      }
      style={bgStyle}
    >
      <div className={hasBg ? 'bg-color-variant box-centered' : 'box-centered'}>
        <h2 className={line ? 'underline centered' : 'underline centered line-hidden'} style={titleStyle}>{title ? title : null}</h2>
        {text ? <p className="centered">{text}</p> : null}
        {localLink ? (
          <Link to={'/' + createLangShortcut(linkLang) + '/' + localLink}>
            <button style={ctaStyle}>{action}</button>
          </Link>
        ) : externalLink ? (
          <a href={externalLink} target="_blank" rel="noreferrer">
            <button style={ctaStyle}>{action}</button>
          </a>
        ) : null}
      </div>
    </section>
  );
}
